export var LovFieldType;
(function (LovFieldType) {
    LovFieldType["INT"] = "INT";
    LovFieldType["TEXT"] = "TEXT";
    LovFieldType["DATE"] = "DATE";
    LovFieldType["DATETIME"] = "DATETIME";
    LovFieldType["POPUP"] = "POPUP";
    LovFieldType["SELECT"] = "SELECT";
})(LovFieldType || (LovFieldType = {}));
export var ViewMode;
(function (ViewMode) {
    ViewMode["default"] = "default";
    ViewMode["button"] = "button";
})(ViewMode || (ViewMode = {}));
export var PrefixRule;
(function (PrefixRule) {
    PrefixRule["start"] = "start";
    PrefixRule["end"] = "end";
    PrefixRule["include"] = "include";
})(PrefixRule || (PrefixRule = {}));
export var SearchAction;
(function (SearchAction) {
    SearchAction["blur"] = "blur";
    SearchAction["input"] = "input";
})(SearchAction || (SearchAction = {}));
